import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const usePackagesTypes = packageNumber => {
  const [value, setValue] = useState();
  const {
    t
  } = useTranslation();
  if (!value) {
    setValue({
      0: 'FREE',
      1: t('PACKAGES-INFO.grow'),
      2: t('PACKAGES-INFO.studio'),
      3: t('PACKAGES-INFO.infinity'),
      free: 'FREE'
    });
  }
  if (value) {
    if (packageNumber !== undefined && packageNumber !== null) {
      return value["".concat(packageNumber)];
    }
    return value;
  }
};
export { usePackagesTypes };